import React from 'react'
import SectionType from 'models/types/ts/sectionType'
import { Container, Heading } from 'layouts'
import Accordion from 'layouts/accordion'
import FaqStructuredData from 'features/structured-data/FaqStructuredData'
import ContentType from 'models/types/ts/contentType'
import style from './Faq.module.scss'

interface Props {
    section: SectionType
}

const Faq = ({ section }: Props): JSX.Element => {
    const {
        headline,
        contentCollection: { total, items },
    } = section
    return (
        <div className={style.faq}>
            <Container>
                <Heading size="regular">{headline}</Heading>
                <div className={style.content}>
                    {total > 0 &&
                        items.map((item: ContentType) => (
                            <Accordion
                                title={item.headline}
                                key={item.headline}
                            >
                                {item.body}
                            </Accordion>
                        ))}
                </div>
            </Container>
            <FaqStructuredData items={items} />
        </div>
    )
}

export default Faq
